import { useState } from "react";
import { useAuth } from "../AuthContext";
import { fmtError } from "../api";

export default function PinOverlay({ store, onDone, onCancel }) {
  const { verifyPin } = useAuth();
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (val) => {
    setBusy(true); setErr("");
    try {
      await verifyPin(val, store);
      onDone(store);
    } catch (e) {
      setErr(fmtError(e.response?.data?.detail) || e.message);
      setPin("");
    } finally { setBusy(false); }
  };

  const press = (k) => {
    if (busy) return;
    if (pin.length >= 4) return;
    const next = pin + k;
    setPin(next);
    if (next.length === 4) submit(next);
  };
  const back = () => { if (!busy) setPin(pin.slice(0, -1)); setErr(""); };

  return (
    <div className="pin-overlay" data-testid="pin-overlay">
      <div className="pin-box">
        <div className="pin-title">Store Access PIN</div>
        <div className="pin-sub">Enter PIN for: {store.name}</div>
        {err && <div className="pin-error" data-testid="pin-error">{err}</div>}
        <div className="pin-dots">
          {[0,1,2,3].map((i) => (
            <div key={i} className={`pin-dot ${i < pin.length ? "filled" : ""}`} />
          ))}
        </div>
        <div className="pin-pad">
          {[1,2,3,4,5,6,7,8,9].map((n) => (
            <div key={n} className="pin-key" onClick={() => press(String(n))} data-testid={`pin-key-${n}`}>{n}</div>
          ))}
          <div className="pin-key special" onClick={onCancel} data-testid="pin-cancel">Cancel</div>
          <div className="pin-key" onClick={() => press("0")} data-testid="pin-key-0">0</div>
          <div className="pin-key special" onClick={back} data-testid="pin-back">⌫</div>
        </div>
      </div>
    </div>
  );
}
